module.exports = __webpack_public_path__ + "static/media/health_care_fund.b705f415.svg";